document.addEventListener("DOMContentLoaded", function () {
    /** Init Cookie Consent */
    if (!getCookie('consent_modal')) {
        const el = document.getElementById('cookie-consent-bar');
        if(el) {
            el.style.display = 'block';
        }
        if (!getCookie('consent_analytics')) {
            setCookie('consent_analytics', 'deny', 60);
        }
    }

    /** Accept only necessary cookies */
    let onlyNecessaryBtn = document.getElementById("cookie-btn-necessary");
    if(onlyNecessaryBtn) {
        onlyNecessaryBtn.addEventListener('click', function () {
            setCookie('consent_modal', 'deny', 60);
            document.getElementById('cookie-consent-bar').remove();
        });
    }

    /** Accept all cookies */
    let allBtn = document.getElementById("cookie-btn-all");
    if(allBtn) {
        allBtn.addEventListener('click', function () {
            setCookie('consent_analytics', 'allow', 60);
            setCookie('consent_modal', 'deny', 60);
            document.getElementById('cookie-consent-bar').remove();
        });
    }

    /** Show consent **/
    let showConsentBtn = document.querySelector("a[href='#cookies-modal']");
    if(showConsentBtn) {
        showConsentBtn.addEventListener('click', function (e) {
            deleteCookie('consent_analytics');
            deleteCookie('consent_modal');
            location.reload();
        });
    }
});

function setCookie(name, value, days) {
    let expires = "";
    if (days) {
        let date = new Date();
        date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
        expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + (value || "") + expires + "; path=/";
}

function getCookie(name) {
    let nameEQ = name + "=";
    let ca = document.cookie.split(';');
    for (let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) == ' ') c = c.substring(1, c.length);
        if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
}

function deleteCookie( name ) {
    document.cookie = name+'=; Max-Age=-99999999;';
}